import { getGetDocumentQueryKey } from '@modusign/openapi-client-external-document';
import { useQueryClient } from 'react-query';
import { useToggle } from 'react-use';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';

import { ExternalDocument } from '../../../types/ExternalDocument';
import BasicInformationViewer from '../../BasicInformationViewer';
import Editor from './Editor';

interface BasicInformationPanelProps {
  externalDocument: ExternalDocument;
  onIsDirtyChange: (isDirty: boolean) => void;
}

export default function BasicInformationPanel({
  externalDocument,
  onIsDirtyChange,
}: BasicInformationPanelProps) {
  const workspaceId = useWorkspaceId();

  const [isEditing, toggleEditing] = useToggle(false);
  const queryClient = useQueryClient();

  if (isEditing) {
    return (
      <Editor
        externalDocument={externalDocument}
        onCancel={() => {
          onIsDirtyChange(false);
          toggleEditing();
        }}
        onIsDirtyChange={onIsDirtyChange}
        onSuccess={() => {
          onIsDirtyChange(false);
          toggleEditing();
          queryClient.invalidateQueries(getGetDocumentQueryKey(workspaceId, externalDocument.id));
        }}
      />
    );
  }

  return <BasicInformationViewer externalDocument={externalDocument} onClickEdit={toggleEditing} />;
}
